import apiRoutes from "../../Routes/Routes.json";
import HttpClient from "HttpClient";

export const PanelSetupGetAll = (payload: any) => {
  return HttpClient().post(apiRoutes.NGSLis.Compendium.GetAll, payload);
};

export const getPanelTypeLookup = () => {
  return HttpClient().get(apiRoutes.NGSLis.Compendium.GetPanelTypes);
};

export const GetTagsFilterLookup = (labId: number) => {
  return HttpClient().get(
    `${apiRoutes.NGSLis.Compendium.GetTagsAgainstLabIdLookup}/${labId}`
  );
};

export const GetTestListsLookup = (payload: any) => {
  return HttpClient().post(
    apiRoutes.NGSLis.Compendium.TestsAgainstLabIdLookup,
    payload
  );
};

export const SavePanelSetupExpand = (payload: any) => {
  return HttpClient().post(
    apiRoutes.NGSLis.Compendium.SavePanelSetupExpand,
    payload
  );
};

export const PanelSetupSaveData = (payload: any) => {
  return HttpClient().post(apiRoutes.NGSLis.Compendium.SavePanelSetup, payload);
};

export const TestSetupSaveData = (payload: any) => {
  return HttpClient().post(apiRoutes.NGSLis.Compendium.SaveTestSetup, payload);
};

export const TestSetupGetAll = (payload: any) => {
  return HttpClient().post(
    apiRoutes.NGSLis.Compendium.TestSetupGetAll,
    payload
  );
};
